import { lazy } from "react";
import {BaseRouter} from "../model/common/baseRouter";
import PvMaintGuard from "../guard/pvMaintGuard";
const PvStatMon = lazy(() => import("app/pages/pvmaint/stat/PvStatMonBase"));
const Efficiency = lazy(() => import("app/pages/pvmaint/efficiency/EfficiencyBase"));
const BsnStatus = lazy(() => import("app/pages/pvmaint/detail/PvDetailBase"));
const DailyReport = lazy(() => import("app/pages/pvmaint/report/PvMaintDailyReportBase"));

export const pvMaintRouter: BaseRouter[] = [
  { path: "/pvmaint/mon", element: <PvMaintGuard><PvStatMon /></PvMaintGuard> },
  { path: '/pvmaint/eff', element: <PvMaintGuard><Efficiency /></PvMaintGuard>},
  { path: "/pvmaint/dtl", element: <PvMaintGuard><BsnStatus /></PvMaintGuard>},
  { path: "/pvmaint/rpt", element: <PvMaintGuard><DailyReport /></PvMaintGuard>},
];
